import { initLifecycleFunc } from '../../resources/js/module/lifecycle'
import { initModal } from '../../resources/js/module/modal'
import { initTabs } from '../../resources/js/module/tabs'
import { initBuildLines } from '../../resources/js/module/addLinesTireLifecycle'

$(document).ready(function () {
  initLifecycleFunc()
  initModal()
  initTabs()
  initBuildLines()

  $(document).on('openModal', function (event, idModal) {

    const modal = $(`[data-modal="${idModal}"]`)
    const section = modal.closest('section')

    section.css({
      'position': 'relative',
      'z-index': 100,
    })

  })

  $(document).on('closeModal', function (event, idModal) {

    const modal = $(`[data-modal="${idModal}"]`)
    const section = modal.closest('section')

    section.css({
      'position': 'static',
    })
  })
})

$(window).resize(function () {
  initBuildLines()
})
